export default {
    "de": {
        "common": {
            "messages": {
                "connection_needed": "Für diese Funktion ist eine Internetverbindung notwendig",
                "connection_waiting": "Sie sind offline. Es wird auf eine Internetverbindung gewartet...",
                "save_deferred": "Sie sind offline. Der Vorgang wird abgeschlossen sobald Sie wieder eine Internetverbindung haben."
            },
            "alerts": {
                "offline": "Sie sind offline.",
                "back_online": "Sie sind wieder online.",
                "tasks_deferred": "1 Vorgang wird abgeschlossen sobald Sie wieder online sind. | {count} Vorgänge werden abgeschlossen sobald Sie wieder online sind.",
                "tasks_running": "1 offener Vorgang wird abgeschlossen. | {count} offene Vorgänge werden abgeschlossen."
            }
        },

        "buttons": {
            "add_picture": "Foto hinzufügen"
        },

        "nav": {
            "overview": "Übersicht",
            "calendar": "Kalender",
            "profile": "Profil",
            "logout": "Logout"
        },
        "notifications": {
            "title": {
                "technician_request_send": "Neue Anfrage",
                "technician_request_respond": "Montageanfrage beantwortet",
                "technician_request_revoke": "Montageanfrage zurückgezogen",
                "technician_request_cancel": "Montagetermin storniert",
                "job_close_cancelled": "Montageauftrag abgebrochen",
                "job_close_unfinished": "Montageauftrag unvollständig abgeschlossen",
                "job_close_finished": "Montageauftrag abgeschlossen"
            }
        }
    }
}